import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { Download, Share } from "lucide-react";

export default function InstallPWA() {
  const { t } = useI18n();
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSHint, setShowIOSHint] = useState(false);

  useEffect(() => {
    const ios = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(ios);
    const alreadyInstalled = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
    setInstalled(alreadyInstalled);

    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  if (installed) return null;
  const showBtn = prompt || isIOS;
  if (!showBtn) return null;

  const onClick = async () => {
    if (prompt) {
      prompt.prompt();
      const { outcome } = await prompt.userChoice;
      if (outcome === "accepted") setInstalled(true);
      setPrompt(null);
    } else if (isIOS) {
      setShowIOSHint((s) => !s);
    }
  };

  return (
    <div className="relative">
      <button
        data-testid="install-pwa-btn"
        onClick={onClick}
        className="flex items-center gap-1.5 px-2.5 py-1 rounded-sm border border-emerald-500/40 bg-emerald-500/10 text-emerald-300 text-[10px] font-mono uppercase tracking-widest hover:bg-emerald-500/20 transition-colors"
      >
        <Download className="w-3 h-3" strokeWidth={1.5} />
        {t("install_app")}
      </button>
      {isIOS && showIOSHint && (
        <div className="absolute top-9 right-0 z-40 w-64 border border-border/60 rounded-sm bg-[#09090B] p-3 text-xs text-zinc-300 shadow-lg">
          <div className="font-display font-bold mb-1 text-sm text-white">Add to Home Screen</div>
          <div className="flex items-start gap-2 text-[11px]">
            <div>1. Tap</div>
            <Share className="w-3.5 h-3.5 inline text-emerald-400" />
            <div>Share</div>
          </div>
          <div className="text-[11px] mt-1">2. Choose "Add to Home Screen"</div>
        </div>
      )}
    </div>
  );
}
